import "./i18n/config";
import React, { useEffect, useRef } from "react";
import styles from "./templates-widget.module.scss";
import classnames from "classnames";
import { MsgPreview } from "./components/MsgPreview";
import { TemplatesList } from "./components/TemplatesList";
import { TemplateWidgetError } from "./components/TemplateWidgetError";
import { useDependencyInjector } from "@whatslly/commons/di";
import type { QueryResponseType } from "@whatslly/types/QueryResponse";
import { observer } from "mobx-react-lite";
import { TemplatesLoader } from "@whatslly/instant-messaging/react-app/templates-widget/components/TemplatesLoader";
import { SvgV2 } from "@whatslly/ui-components/v2/BaseElements/SvgV2";
import type { IImTemplatesStore } from "@whatslly/instant-messaging/commons/IImTemplatesStore";
import { formatTemplateMsg, ImTemplatesStoreSymbol } from "@whatslly/instant-messaging/commons/IImTemplatesStore";
export const TemplatesWidget: React.FC<{
  widgetOpen: boolean;
  queryResponse: QueryResponseType;
}> = observer(({ queryResponse, ...props }) => {
  const store = useDependencyInjector<IImTemplatesStore>(ImTemplatesStoreSymbol);
  store.setProps({ queryResponse, ...props });

  const wrapperRef = useRef<HTMLDivElement>(null);
  const containerRef = useRef<HTMLDivElement>(null);
  useEffect(
    () => () => {
      store.closeTemplateWidget();
    },
    []
  );

  return (
    <div className={classnames(styles.main, styles.mainV2, { [styles.open]: store.isOpen })}>
      {store.isOpen && (
        <>
          <div
            className={classnames(styles.sizeToggleContainer, { [styles.rotateBack]: store.containerSizeIsBig })}
            onClick={() => {
              store.containerSizeIsBig = !store.containerSizeIsBig;
            }}
          >
            <SvgV2 iconName={"arrow_down"} height={8} width={11} />
          </div>
          {store.previewdTemplate?.msg && <MsgPreview previewMsg={formatTemplateMsg(store.previewdTemplate.msg)} onClose={store.closePreviewMsg} />}
        </>
      )}

      <div
        ref={wrapperRef}
        className={classnames(styles.wrapper, { [styles.open]: store.isOpen })}
        style={{ height: store.height, maxHeight: store.height }}
      >
        <div ref={containerRef} className={classnames(styles.app)}>
          {store.templatesData.case({
            pending: () => <TemplatesLoader />,
            rejected: (error) => (
              <TemplateWidgetError
                allowAdd={store.allowCreateTemplate}
                errorType={error.message}
                templateEditorUrlHref={error.templateEditorUrl}
                close={store.closeTemplateWidget}
              />
            ),
            fulfilled: (data) => <TemplatesList data={data} />,
          })}
        </div>
      </div>
    </div>
  );
});
